import { useConnectorOAuthResults } from "@/components/connectors/useConnectorOAuthResults.ts";
import { GoogleCalendarIcon } from "@/components/icons/GoogleCalendarIcon.tsx";
import { OutlookIcon } from "@/components/icons/OutlookIcon.tsx";
import { useStepUp } from "@/lib/useStepUp.ts";
import { resolveApiPath } from "@/lib/utils.ts";

export const ConnectCalendarSection = () => {
  useConnectorOAuthResults();
  // Both links start a Google or Microsoft connector, which an account proven
  // only by a claim link must prove its number for first.
  const stepUp = useStepUp();
  const linkProps = (provider: "google" | "microsoft") =>
    stepUp.required
      ? { href: stepUp.href }
      : {
          href: resolveApiPath(`/api/a/connectors/connect/${provider}`),
          target: "_blank",
          rel: "noopener noreferrer",
        };

  return (
    <div className="flex flex-col gap-3">
      <span className="text-sm font-medium text-foreground">Connect calendar</span>
      <div className="flex flex-col gap-1">
        <a
          {...linkProps("google")}
          className="flex w-full items-center gap-2.5 rounded-md py-1.5 text-sm text-foreground/80 hover:bg-accent/50 transition-colors"
        >
          <GoogleCalendarIcon className="size-4" />
          <span className="flex-1 text-left">Google Calendar</span>
        </a>
        <a
          {...linkProps("microsoft")}
          className="flex w-full items-center gap-2.5 rounded-md py-1.5 text-sm text-foreground/80 hover:bg-accent/50 transition-colors"
        >
          <OutlookIcon className="size-4" />
          <span className="flex-1 text-left">Outlook Calendar</span>
        </a>
      </div>
    </div>
  );
};
